import React from "react";
import EmailMe from "../EmailMe";
import { Wrapper, Nav, NavItem, NavLink } from "./style";
import SubscribeForm from "../SubscribeForm";

const Menu = () => (
  <Wrapper>
    <NavItem className="col-start-2">
      <EmailMe text="Email" />
    </NavItem>
    <NavItem>
      <a
        href="https://www.facebook.com/nausicaamusic/"
        rel="noopener noreferrer"
        target="_blank"
      >
        Facebook
      </a>
    </NavItem>
    <NavItem>
      <SubscribeForm />
    </NavItem>
  </Wrapper>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/index.js